import React from 'react';
import Link from '../../common/TrackedLink';
import ButtonLink from '../../common/TrackedButtonLink';
import TestResult from "../../category/common/TestResult";
import VideoLeftTextRight from "../../components/page/VideoLeftTextRight";

const ProtectionTypes = () => {
	const videoTextData = {
		videoId: 6329986431112,
		titleText: "Fire Protection that Passes the Test.",
		descriptionText: `<p>Our safes are tested to rigorous standards to ensure that your important documents and valuables are kept safe during unpredictable conditions of a fire.</p>`,
		buttonText: 'View Safes',
		buttonTo: '/learn/fire-and-water-safes'
	};
	return (
		<section className="protection-type" id="types-of-protection">
			<div className="row fire">
				<div className="col sm-12">
					<h2 className="title">Protection for every peril</h2>
					<h3 className="sub-head">
						<Link to="/fire-safes">Fire resistance</Link>
					</h3>
					<p className="descr">Our Underwriters Laboratory &#40;UL&#41; Classified safes can withstand peak temperatures ranging from 1150&deg; F &ndash; 1850&deg; F, keeping your valuables safe and undamaged for up to two hours of fire exposure. <a href="https://insights.masterlock.com/articles/5-things-you-need-to-know-about-your-safes-fire-rating" target="_blank">Learn more about a safe's fire rating</a>.</p>
				</div>

				<div className="pt-3">
					<VideoLeftTextRight data={videoTextData} />
				</div>

				<TestResult
					imgSrc1={ require('../../../resources/img/icons/half-hour-icon.png') }
					alt1={ 'Half Hour' } title1={ 'UL 1&#47;2 hour test' }
					subTitle1={ 'withstands 1550&deg;F (843&deg;C) for 1&#47;2 hour' }
					imgSrc2={ require('../../../resources/img/icons/hour-icon.png') }
					alt2={ 'Hour' }
					title2={ 'UL 1-hour test' }
					subTitle2={ 'withstands 1700&deg;F (927&deg;C) for 1 hour' }
					imgSrc3={ require('../../../resources/img/icons/two-hour-icon.png') }
					alt3={ 'Two Hour' } title3={ 'UL 2-hour test' }
					subTitle3={ 'withstands 1850&deg;F (1010&deg;C) for 2 hour' }
				/>

				<div className="col sm-6 callout">
					<h4 className="sub-head">Explosion Hazard</h4>
					<p className="descr">Flash fires happen. Sudden, extreme temperatures can cause the air inside the safe to expand so rapidly that the structural integrity is compromised. Our safes are UL classified to withstand this extreme event.</p>
					<div className="icon">
						<img
							src={require('../../../resources/img/icons/explosion-icon.png')}
							alt="Explosion"
						/>
					</div>
				</div>
				<div className="col sm-6 callout">
					<h4 className="sub-head">Impact Resistance</h4>
					<p className="descr">During a fire, your safe may be vulnerable to falling through floors of the burning structure. UL Classified impact resistance means our safe doors stay closed&#45;and your valuables protected.</p>
					<div className="icon">
						<img
							src={require('../../../resources/img/icons/impact-icon.png')}
							alt="Impact"
						/>
					</div>
				</div>
			</div>

			<div className="row protection-levels" id="security-protection-type">
				<h3 className="sub-head">Security Protection</h3>
				<p className="descr">From basic protection that keeps people honest, to our maximum protection against a determined thief &#45; Choose the security level that best fits your needs.</p>
				<ul className="callout">
					<li>
						<h4>Basic Protection</h4>
						<p>Privacy key lock deters unwanted viewers or children from accessing the contents of the safe. These safes provide basic protection and are not intended for tool attacks.</p>
						<ButtonLink
							className="btn-primary"
							to="/products/basic-protection"
						>
							View <span className="assistive-text">Basic Protection</span> Safes
						</ButtonLink>
					</li>
					<li>
						<h4>Moderate Protection</h4>
						<p>Durable, solid&#45;steel construction and a tether cable on most models provide moderate protection against brief attacks.</p>
						<ButtonLink
							className="btn-primary"
							to="/products/moderate-protection"
						>
							View <span className="assistive-text">Moderate Protection</span> Safes
						</ButtonLink>
					</li>
					<li>
						<h4>High Protection</h4>
						<p>Solid&#45;steel construction, pry&#45;resistant door&#47;body and heavy duty locks provide higher protection against tool attacks. Many models are California DOJ certified for firearm storage and protection.</p>
						<ButtonLink
							className="btn-primary"
							to="/products/high-protection"
						>
							View <span className="assistive-text">High Protection</span> Safes
						</ButtonLink>
					</li>
					<li>
						<h4>Maximum Protection</h4>
						<p>For maximum protection these safes offer 2&#45;4 live&#45;locking bolts and pry-resistant hinge bars to help provide additional protection from forced entry. Select models include solid steel construction, dead bolts, anti-drill door and loud audible alarm for unauthorized access attempts.</p>
						<ButtonLink
							className="btn-primary"
							to="/products/maximum-protection"
						>
							View <span className="assistive-text">Maximum Protection</span> Safes
						</ButtonLink>
					</li>

				</ul>
			</div>

			<div className="row water">
				<div className="col sm-12">
					<h3 className="sub-head">
						<Link to="/fire-waterproof-safes">Water Protection</Link>
					</h3>
					<p className="descr">Flash floods can happen anywhere and anytime, and can lead to devastating damage. Our waterproof and water resistant safes ensure your valuables will remain dry through extreme exposure to water.</p>
					<ButtonLink
						className="btn-primary"
						to="/products/fire-waterproof-safes"
					>
						View <span className="assistive-text">Fire Waterproof</span> Safes
					</ButtonLink>
				</div>
				<div className="col sm-12 callout last">
					<h4 className="sub-head">Waterproof</h4>
					<p className="descr">Electrical Testing Laboratory &#40;ETL&#41; verified waterproof products are vigorously tested to remain dry even through extreme exposure to water for up to 72 hours.</p>
					<div className="icon">
						<img
							src={require('../../../resources/img/icons/waterproof-icon.png')}
							alt="Waterproof"
						/>
					</div>
				</div>
			</div>
		</section>
	);
};

export default ProtectionTypes;


// WEBPACK FOOTER //
// ./src/pages/learn/buyingGuide/ProtectionTypes.js